var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.edit.isLoading)?_c('BaseLoading',{attrs:{"is-full-page":""}}):_c('AccordionKeysForm',{attrs:{"is-edit":""}})}
var staticRenderFns = []

export { render, staticRenderFns }